// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1vDPi","clickable":"Table_clickable__SfChQ","easyTable":"Table_easyTable__1bA6o"};